import * as React from 'react';
import * as styles from './table.module.scss';
import SortButton from './sort-button';

interface Props {
  // text displayed in the th cell
  title: string;
  // th attribute defining the values the header pertains to
  scope?: 'col' | 'row';
  // name of the field ordered by this column
  orderField?: string;
  // orderField currently being used for sort
  orderColumn?: string;
  // current sort direction
  orderDirection?: 'asc' | 'desc' | null;
  // handler to be called on click events to reorder columns
  reorderHandler?: (orderField: string, direction: 'asc' | 'desc') => void;
}

/**
 * HeaderCell -- renders th in table header with optional sorting buttons
 * @param title text displayed in the th cell
 * @param scope th attribute defining the values the header pertains to
 * @param orderField name of the field ordered by this column
 * @param orderColumn orderField currently being used for sort
 * @param orderDirection current sort direction
 * @param reorderHandler handler to be called on click events to reorder columns
 */
const HeaderCell = ({ title, scope, orderField, orderColumn, orderDirection, reorderHandler }: Props) => {
  const clickHandler = () => {
    let direction: 'asc' | 'desc';
    if (orderField != orderColumn) {
      direction = 'asc';
    } else {
      direction = orderDirection == 'asc' ? 'desc' : 'asc';
    }
    reorderHandler(orderField, direction);
  };
  return (
    <th scope={scope}>
      <div className={styles.headerCellInner}>
        {orderColumn ? (
          <React.Fragment>
            <button aria-label={`Order by ${title}`} title={`Order by ${title}`} onClick={clickHandler}>
              {title || ''}
            </button>
            <div className={styles.sortGroup}>
              <SortButton
                direction="Ascending"
                current={orderField == orderColumn && orderDirection == 'asc'}
                onClick={() => reorderHandler(orderField, 'asc')}
              />
              <SortButton
                direction="Descending"
                current={orderField == orderColumn && orderDirection == 'desc'}
                onClick={() => reorderHandler(orderField, 'desc')}
              />
            </div>
          </React.Fragment>
        ) : (
          <span>{title || ''}</span>
        )}
      </div>
    </th>
  );
};

export default HeaderCell;
